import React from 'react';
import HyperLink from 'components/Core/HyperLink';
import WebsiteImage from 'components/WebsiteImage';

const Link = ({ item, ...otherProps }) => {
  const label = item?.label;
  const labelToRender = label?.endsWith('Beta') ? (
    <>
      {label?.slice(0, -4)} <span class="beta">Beta</span>
    </>
  ) : (
    label
  );

  return (
    <HyperLink
      className="font-h6 min-xl simple-nav-item"
      data-position="Header - Menu Item CTA"
      href={item?.url}
      {...otherProps}
    >
      <WebsiteImage {...item?.icon} widthDesktop="28px" heightDesktop="28px" />
      <h6>{labelToRender}</h6>
    </HyperLink>
  );
};

export default Link;
